import { formatCents } from '@/lib/format';

export interface WhatsappPayoutBreakdownEntry {
  campaign_name: string;
  earned_cents: number;
}

export interface BankData {
  cpf: string;
  bank: string;
  agency: string;
  account: string;
  pixKey?: string;
}

export interface BuildWhatsappPayoutUrlArgs {
  phone: string;
  email: string;
  name: string;
  breakdown: WhatsappPayoutBreakdownEntry[];
  totalCents: number;
  paidOutCents?: number;
  bankData?: BankData;
}

export function buildWhatsappPayoutUrl({
  phone,
  email,
  name,
  breakdown,
  totalCents,
  paidOutCents,
  bankData,
}: BuildWhatsappPayoutUrlArgs): string {
  const lines: string[] = [
    'Olá! Gostaria de solicitar meu saque na Autoclipper.',
    '',
    'Dados:',
    `- Email da conta: ${email}`,
    `- Nome completo: ${name}`,
    `- CPF/CNPJ: ${bankData?.cpf ?? ''}`,
    `- Banco: ${bankData?.bank ?? ''}`,
    `- Agência: ${bankData?.agency ?? ''}`,
    `- Conta: ${bankData?.account ?? ''}`,
    `- Chave PIX: ${bankData?.pixKey ?? ''}`,
    '',
    'Projetos:',
  ];

  for (const entry of breakdown) {
    if (!entry.earned_cents || entry.earned_cents <= 0) continue;
    lines.push(`- ${entry.campaign_name}: ${formatCents(entry.earned_cents, 'BRL')}`);
  }

  if (paidOutCents && paidOutCents > 0) {
    lines.push(`Já recebido: ${formatCents(paidOutCents, 'BRL')}`);
  }

  lines.push(`Valor total solicitado: ${formatCents(totalCents, 'BRL')}`);
  lines.push('');
  lines.push('Fico no aguardo');

  const text = encodeURIComponent(lines.join('\n'));
  return `https://api.whatsapp.com/send/?phone=${encodeURIComponent(phone)}&text=${text}&type=phone_number&app_absent=0`;
}
